import { Injectable } from '@angular/core';
import { filter, Observable, Subject } from 'rxjs';
import { ModalWindowActionPayload } from './modal-window.model';

@Injectable()
export class ModalWindowService {
  showModal$ = new Subject<string>();
  userAction$ = new Subject<ModalWindowActionPayload>();

  constructor() {}

  prompt = (modalId: string): Observable<ModalWindowActionPayload> => {
    this.showModal$.next(modalId);
    return this.userAction$.pipe(filter(payload => payload?.modalId === modalId));
  };
}
